import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  styled,
} from "@mui/material";
import { useSelector } from "react-redux";

const CheckboxInput = ({
  checked,
  label,
  onChange,
  color,
  disabled,
  isLoading,
  ...rest
}) => {
  const userState = useSelector(state => state?.userState);
  const theme = userState?.publisher?.theme_color;
  return label ? (
    <FormControlLabel
      control={
        isLoading ? (
          <Box mx={1.5}>
            <CircularProgress size={16} />
          </Box>
        ) : (
          <CustomCheckbox
            customColor={color || theme}
            checked={checked}
            onChange={onChange}
            disabled={disabled || isLoading}
            {...rest}
          />
        )
      }
      {...rest}
      label={label}
    />
  ) : isLoading ? (
    <Box mx={1.5}>
      <CircularProgress size={16} />
    </Box>
  ) : (
    <CustomCheckbox
      customColor={color || theme}
      checked={checked}
      onChange={onChange}
      disabled={disabled || isLoading}
      {...rest}
    />
  );
};

const CustomCheckbox = styled(Checkbox)(({ customColor }) => ({
  "&.MuiCheckbox-root": {
    color: customColor || "#111827",
    "&.Mui-checked": {
      color: customColor || "#111827",
    },
    "&.Mui-disabled": {
      color: `${customColor || "#111827"}`,
      opacity: 0.2,
    },
  },
}));

export default CheckboxInput;
